import React from 'react';
import range from 'lodash/range';
import round from 'lodash/round';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineSelect from '../InlineSelect';

const percentOptions = range(0, 1.1, 0.1).map(value => ({
  value: round(value, 1),
  display: `${round(value * 100)}%`,
}));

const footprintOptions = range(0.5, 1.6, 0.1).map(value => ({
  value: round(value, 1),
  display: `${round(value * 100)}%`,
}));

const priceOptions = range(0.2, 3.2, 0.2).map(value => ({
  value: round(value, 1),
  display: `${round(value * 100)}%`,
}));

const GoOrganic = ({
  t,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('Currently, there is not conclusive scientific evidence that organic food, in general, has lower greenhouse gas emissions than conventional products. However, there are a lot of environmental reasons to buy organic food including reducing chemical toxins in the environment and encouraging sustainable farming practices, which frequently accompany organic farming.')}
      </p>
      <table className="table">
        <thead>
          <tr>
            <td />
            <th>{t('I currently eat')}</th>
            <th>{t('I pledge to eat')}</th>
          </tr>
        </thead>
        <tbody>
          {
            [
              { title: t('organic produce'), currentApiKey: 'input_takeaction_go_organic_eatorgproduce', pledgeApiKey: 'input_takeaction_go_organic_pledgeorgprod' },
              { title: t('organic meat'), currentApiKey: 'input_takeaction_go_organic_eatorgmeat', pledgeApiKey: 'input_takeaction_go_organic_pledgeorgmeat' },
              { title: t('organic dairy'), currentApiKey: 'input_takeaction_go_organic_eatorgdairy', pledgeApiKey: 'input_takeaction_go_organic_pledgedairy' },
            ].map(foodType => (
              <tr key={foodType.currentApiKey}>
                <td>{foodType.title}</td>
                <td>
                  <InlineSelect
                    options={percentOptions}
                    apiKey={foodType.currentApiKey}
                  />
                </td>
                <td>
                  <InlineSelect
                    options={percentOptions}
                    apiKey={foodType.pledgeApiKey}
                  />
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
    <div className="action-details__facts">
      {t('Organic products are available in nearly 20,000 natural foods stores, and are sold in nearly three-quarters of all conventional grocery stores')}
    </div>
    <div className="action-details__assumptions">
      <p><b>{t('Carbon footprint of organic food (% of conventional)')}</b></p>
      <ul>
        <li>
          {t('Produce')}
          <InlineSelect
            percent
            options={footprintOptions}
            apiKey="input_takeaction_go_organic_myproduce"
          />
        </li>
        <li>
          {t('Meat')}
          <InlineSelect
            percent
            options={footprintOptions}
            apiKey="input_takeaction_go_organic_mymeat"
          />
        </li>
        <li>
          {t('Dairy')}
          <InlineSelect
            percent
            options={footprintOptions}
            apiKey="input_takeaction_go_organic_mydairy"
          />
        </li>
      </ul>
      <p><b>{t('Price of organic food (% of conventional)')}</b></p>
      <ul>
        <li>
          {t('Produce')}
          <InlineSelect
            percent
            options={priceOptions}
            apiKey="input_takeaction_go_organic_myprodcost"
          />
        </li>
        <li>
          {t('Meat')}
          <InlineSelect
            percent
            options={priceOptions}
            apiKey="input_takeaction_go_organic_mymeatcost"
          />
        </li>
        <li>
          {t('Dairy')}
          <InlineSelect
            percent
            options={priceOptions}
            apiKey="input_takeaction_go_organic_mydairycost"
          />
        </li>
      </ul>
    </div>
  </div>
);

GoOrganic.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
};

const mapStateToProps = (state, ownProps) => [].reduce((resultProps, resultKey) => ({
  ...resultProps,
  [resultKey]: s.results(resultKey)(state, ownProps),
}), {});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('goOrganic'),
  connect(mapStateToProps, mapDispatchToProps)(GoOrganic),
);
